import api from './api';

class ServicesService {
  // Get all services
  async getAllServices() {
    try {
      const response = await api.get('/services');
      return response.data;
    } catch (error) {
      console.error('Error fetching services:', error);
      throw error;
    }
  }

  // Get featured services
  async getFeaturedServices() {
    try {
      const response = await api.get('/services/featured');
      return response.data;
    } catch (error) {
      console.error('Error fetching featured services:', error);
      throw error;
    }
  }

  // Get services by category
  async getServicesByCategory(category) {
    try {
      const response = await api.get(`/services/category/${category}`);
      return response.data;
    } catch (error) {
      console.error('Error fetching services by category:', error);
      throw error;
    }
  }

  // Get services by type
  async getServicesByType(type) {
    try {
      const response = await api.get(`/services/type/${type}`);
      return response.data;
    } catch (error) {
      console.error('Error fetching services by type:', error);
      throw error;
    }
  }

  // Search services by name
  async searchServices(name) {
    try {
      const response = await api.get('/services/search', {
        params: { name },
      });
      return response.data;
    } catch (error) {
      console.error('Error searching services:', error);
      throw error;
    }
  }

  // Find nearby services
  async findNearbyServices(lat, lng, radius = 5) {
    try {
      const response = await api.get('/services/nearby', {
        params: { lat, lng, radius },
      });
      return response.data;
    } catch (error) {
      console.error('Error finding nearby services:', error);
      throw error;
    }
  }

  // Get services by price range
  async getServicesByPriceRange(minPrice, maxPrice) {
    try {
      const response = await api.get('/services/price-range', {
        params: { min: minPrice, max: maxPrice },
      });
      return response.data;
    } catch (error) {
      console.error('Error fetching services by price range:', error);
      throw error;
    }
  }

  // Get service by ID
  async getServiceById(id) {
    try {
      const response = await api.get(`/services/${id}`);
      return response.data;
    } catch (error) {
      console.error('Error fetching service:', error);
      throw error;
    }
  }

  // Create service (admin only)
  async createService(serviceData) {
    try {
      const response = await api.post('/services', serviceData);
      return response.data;
    } catch (error) {
      console.error('Error creating service:', error);
      throw error;
    }
  }

  // Update service (admin only)
  async updateService(id, serviceData) {
    try {
      const response = await api.patch(`/services/${id}`, serviceData);
      return response.data;
    } catch (error) {
      console.error('Error updating service:', error);
      throw error;
    }
  }

  // Delete service (admin only)
  async deleteService(id) {
    try {
      const response = await api.delete(`/services/${id}`);
      return response.data;
    } catch (error) {
      console.error('Error deleting service:', error);
      throw error;
    }
  }

  // Get service categories
  getServiceCategories() {
    return [
      'Transportation',
      'Food & Dining',
      'Shopping',
      'Medical',
      'Banking',
      'Tourism',
      'Religious Services',
      'Emergency Services',
    ];
  }
}

const servicesService = new ServicesService();
export default servicesService;
